/* ============================================================
   AJAX ADD TO CART — HOMEPAGE PRODUCT CARDS ONLY
   SAFE FOR SHOPIFY CHECKOUT
   ============================================================ */
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('[AJAX Cart] Initializing (safe mode)');
    document.addEventListener('submit', handleFormSubmit, true);
  }

  function handleFormSubmit(e) {
    const form = e.target;
    // 🚫 NEVER intercept cart drawer upsells
    if (form.closest('[data-cart-upsell]')) return;
    // ✅ ONLY product forms
    if (!form.matches('product-form-component form')) return;

    // ✅ NEVER touch Buy Now / Checkout
    if (
      e.submitter &&
      (
        e.submitter.name === 'checkout' ||
        e.submitter.classList.contains('shopify-payment-button__button')
      )
    ) {
      return; // Shopify owns this
    }

    // ✅ Only homepage product cards
    const isProductCard = form.closest('product-card') !== null;
    const isCartUpsell = form.closest('[data-cart-upsell]') !== null;
    if (!isProductCard && !isCartUpsell) return;

    console.log('[AJAX Cart] Homepage Add to Cart intercepted');

    // ❌ Stop native submit ONLY for Add to Cart
    e.preventDefault();
    e.stopImmediatePropagation();

    handleAjaxAddToCart(form, e.submitter);
  }

  function handleAjaxAddToCart(form, submitter) {
    const formData = new FormData(form);

    const addButton =
      submitter ||
      form.querySelector('[ref="addToCartButton"]') ||
      form.querySelector('button[type="submit"]');

    if (!addButton) return;

    addButton.disabled = true;
    const originalText = addButton.textContent;
    addButton.textContent = 'Adding…';

    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1', 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }],
      }),
    })
      .then((r) => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        updateCartCount();

        addButton.textContent = 'Added ✓';
        addButton.classList.add('atc-added');

        setTimeout(() => {
          addButton.textContent = originalText;
          addButton.classList.remove('atc-added');
          addButton.disabled = false;
        }, 1500);
      })
      .catch(() => {
        addButton.textContent = 'Error';
        addButton.disabled = false;

        setTimeout(() => {
          addButton.textContent = originalText;
        }, 1500);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const selectors = [
          '[data-cart-count]',
          '.cart-count',
          '.header__cart-count',
          '#cart-icon-bubble .cart-count-bubble span',
        ];

        selectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((el) => {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden', cart.item_count === 0);
          });
        });

        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart } })
        );
      });
  }
})();
